import React, { Fragment } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { NavLink as Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';

import Utils from '../shared/util.js';
import ChallengeTimer from '../challenge-card/challenge-timer.component.js';
import ExternalChallenge from '../external-challenge/external-challenge.component.js';
import {
	PrimaryButton,
	SecondaryButton,
	RoundButton,
} from '../ui-toolkit/buttons.js';
import FormattedNumberCurrency from '../shared/formattedNumberCurrency.component.js';
import ContactsService from '../../features/contacts/contacts.service.js';

import solutionsIcon from '../../assets/images/solver-challenge-card/solutions.svg';
import messageIcon from '../../assets/images/contacts-messages/send-message.svg';
import viewsIcon from '../../assets/images/eye.svg';
import challengeTypeIcon from '../../assets/images/solver-challenge-card/challenge-type.svg';

import './solver-challenge-details-card.scss';


const openAnonymousChat = (challengeId, intl, history) => {
	ContactsService.openAnonymousChat(challengeId)
		.then((chatId) => {
			history.push(`/messages/${chatId}`);
		})
		.catch((error) => {
			Utils.showErrorMessageAlert(error, toast.TYPE.ERROR, intl);
		});
};

const SolverChallengeDetailsCard = ({
	id,
	title,
	award,
	deadline,
	solutionStats,
	status,
	challengeType,
	intl,
	history,
	isExternal,
	externalLink,
	externalLogo,
}) => (
	<div className="solver-challenge-card">
		<h1>{title}</h1>

		<div className="d-flex info">
			{award && (
				<RoundButton className="prize" primary>
					<FormattedNumberCurrency
						number={award.amount}
						currency={award.currencyCode}
					/>
				</RoundButton>
			)}

			{deadline && (
				<ChallengeTimer
					classNames="deadline"
					deadline={deadline}
					status={status}
				/>
			)}
		</div>

		<div className="stats">
			{solutionStats && (
				<div className="stats-wrapper counts">
					<Fragment>
						<div className="d-flex mb-2">
							<div className="icon">
								<img src={viewsIcon} alt="views" />
							</div>

							<FormattedMessage
								id="challenge.card.views"
								values={{
									count: solutionStats.numberSolversVisits || 0,
								}}
							/>
						</div>

						{!isExternal && (
							<div className="d-flex mb-2">
								<div className="icon">
									<img src={solutionsIcon} alt="solutions" />
								</div>

								<FormattedMessage
									id="challenge.card.solutions"
									values={{
										count: solutionStats.numberSolutions || 0,
									}}
								/>
							</div>
						)}

						{status !== 'EVALUATION' && status !== 'CLOSED' && (
							<div className="buttons-wrapper d-none d-sm-block">
								<SecondaryButton
									fullWidth
									className="message-button"
									onClick={() => openAnonymousChat(id, intl, history)}
								>
									<img src={messageIcon} alt="" />

									<FormattedMessage id="solver_challenge_card.send_message" />
								</SecondaryButton>
							</div>
						)}
					</Fragment>
				</div>
			)}

			{challengeType && (
				<div className="stats-wrapper type">
					<div className="d-flex mb-2">
						<div className="icon">
							<img src={challengeTypeIcon} alt="solvers" />
						</div>

						<FormattedMessage
							id="challenge.card.type"
							values={{
								type: challengeType.name,
							}}
						/>
					</div>

					{isExternal && externalLogo && externalLogo.url && (
						<div className="d-flex mb-2">
							<ExternalChallenge externalLogo={externalLogo.url} />
						</div>
					)}

					{status !== 'EVALUATION' && status !== 'CLOSED' && (
						<div className="buttons-wrapper">
							<div className="buttons-wrapper d-block d-sm-none">
								<SecondaryButton
									fullWidth
									className="message-button"
									onClick={() => openAnonymousChat(id, intl, history)}
								>
									<img src={messageIcon} alt="" />

									<FormattedMessage id="solver_challenge_card.send_message" />
								</SecondaryButton>
							</div>

							{isExternal ? (
								<a
									href={externalLink}
									target="_blank"
									rel="noopener noreferrer"
									className="submit-solution-link"
								>
									<PrimaryButton fullWidth className="submit-solution-button">
										<FormattedMessage id="solver_challenge_card.submit_solution" />
									</PrimaryButton>
								</a>
							) : (
								<Link
									to={`/challenges/${id}/solution/submit-solution`}
									className="submit-solution-link"
								>
									<PrimaryButton fullWidth className="submit-solution-button">
										<FormattedMessage id="solver_challenge_card.submit_solution" />
									</PrimaryButton>
								</Link>
							)}
						</div>
					)}
				</div>
			)}
		</div>
	</div>
);

export default withRouter(injectIntl(SolverChallengeDetailsCard));
